import React from 'react';
import './action.scss';
import { Flexbox } from './Flexbox';

const RedirectButton = ({ children, url , ...props }) => {

  function open(){
    window.open(url , "_blank")
  }
  return (
    <Flexbox className='redirect_button'  gap='0.12rem' onClick={open} {...props}>
      {children}
      {/* {showArrow && (
        <svg xmlns='http://www.w3.org/2000/svg' width='20' height='21' viewBox='0 0 20 21' fill='none'>
          <path d='M10.7959 10.0691L7.08337 6.35664L8.14387 5.29614L12.9169 10.0691L8.14387 14.8421L7.08337 13.7816L10.7959 10.0691Z' fill='#525866' />
        </svg>
      )} */}
    </Flexbox>
  );
};

export default RedirectButton;
